<form class="sgt-usuario-permissao-meta" #form="ngForm" novalidade>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title mb-0">
                Metas
            </h6>
           <small class="card-subtitle">Selecione as permissões que este usuário tem acesso no lançamento das Metas</small>
        </div>

        <ul class="list-group list-group-flush" *ngIf="entity">
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeEditarMetas" name="podeEditarMetas" id="podeEditarMetas">
                    <label class="custom-control-label" for="podeEditarMetas">Editar Metas</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário lançar e editar os valores das metas</p>
            </li>
        </ul>
    </div>
</form>
